import React, { useState } from "react";
import { Button, TextInput } from "@utahdts/utah-design-system";
import useSectionConditionFacilityCount from "../../hooks/siteVisits/useSectionConditionFacilityCount";
import "./siteVisits.css";

const SectionConditionFacilityCountTest = ({ facilityFilter }) => {
  const [pwsId, setPwsId] = useState("");
  const [testedInputKey, setTestedInputKey] = useState(null);

  const { data, loading, errors, fetchFacilityCount } = useSectionConditionFacilityCount();

  const currentInputKey = JSON.stringify({ pwsId: pwsId.trim(), facilityFilter });
  const showResult = testedInputKey === currentInputKey;
  const canTest = pwsId.trim() !== "" && !loading.facilityCount;

  const handleTest = () => {
    if (!canTest) return;
    setTestedInputKey(currentInputKey);
    fetchFacilityCount({ variables: { pwsId: pwsId.trim(), facilityFilter } });
  };

  return (
    <div className="site-visits-facility-count-test">
      <div className="site-visits-facility-count-test__controls">
        <TextInput
          id="condition-test-pws-id"
          label="Test Water System (PWS ID)"
          value={pwsId}
          onChange={(e) => setPwsId(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleTest()}
          maxLength={20}
          className="site-visits-field-control"
        />
        <Button id="condition-test-button" onClick={handleTest} isDisabled={!canTest}>
          Test
        </Button>
      </div>
      {showResult && loading.facilityCount && <p>Counting facilities...</p>}
      {showResult && !loading.facilityCount && errors.facilityCount && (
        <p className="site-visits-facility-filter-error">{errors.facilityCount.message}</p>
      )}
      {showResult && !loading.facilityCount && !errors.facilityCount && data.facilityCount !== null && (
        <p className="site-visits-facility-count-test__result">
          <strong>Matching facilities:</strong>
          <span className="site-visits-meta-value">{data.facilityCount}</span>
        </p>
      )}
    </div>
  );
};

export default SectionConditionFacilityCountTest;
